import React, { useRef, useState } from 'react';
import { Box, Hidden, IndicatorDots } from '@doist/marketist';
import { SectionHeader } from 'components/SectionHeader/SectionHeader';
import { TemplateIconCard } from 'components/templates/template-icon-card/template-icon-card';
import { useTranslation } from 'next-i18next';
import css from './similar-templates.module.css';
import type { TemplatePreview } from 'services/templates/types';
export type SimilarTemplatesProps = {
  templates: TemplatePreview[];
};
export function SimilarTemplates({
  templates
}: SimilarTemplatesProps) {
  const {
    t
  } = useTranslation('templates');
  const $scroller = useRef<HTMLDivElement>(null);
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
  function onScroll() {
    const el = $scroller.current;
    if (el) {
      const itemSize = el.scrollWidth / 3;
      setSelectedCardIndex(Math.round(el.scrollLeft / itemSize));
    }
  }
  function onSelectCardIndex(idx: number) {
    const el = $scroller.current;
    if (el) {
      const itemSize = el.scrollWidth / 3;
      el.scrollTo({
        left: itemSize * idx,
        behavior: 'smooth'
      });
    }
  }
  return <>
            <SectionHeader title={t('similarTemplatesHeader')} size="base" className="mbs-32 lg-mbs-0" data-sentry-element="SectionHeader" data-sentry-source-file="similar-templates.tsx" />
            <Box ref={$scroller} className={css.similarTemplates} onScroll={onScroll} aria-roledescription="carousel" aria-label={t('threeSimilarTemplatesCarousel')} data-sentry-element="Box" data-sentry-source-file="similar-templates.tsx">
                <ul className={css.templatesGrid}>
                    {templates.map(t => <li key={t.id}>
                            <TemplateIconCard template={t} forceSetupNarrowStyle />
                        </li>)}
                </ul>
            </Box>
            <Hidden above="md" data-sentry-element="Hidden" data-sentry-source-file="similar-templates.tsx">
                <div className={css.dots}>
                    <IndicatorDots labels={[t('similarTemplate1'), t('similarTemplate2'), t('similarTemplate3')]} activeIndex={selectedCardIndex} onSelectIndex={onSelectCardIndex} style={{
          alignSelf: 'center'
        }} data-sentry-element="IndicatorDots" data-sentry-source-file="similar-templates.tsx" />
                </div>
            </Hidden>
        </>;
}